"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = __importDefault(require("react"));
const prop_types_1 = __importDefault(require("prop-types"));
const react_jss_1 = __importDefault(require("react-jss"));
const uicon_key_horizontal_style_1 = __importDefault(require("./uicon.key.horizontal.style"));
class UiconKeyHorizontal extends react_1.default.PureComponent {
    constructor() {
        super(...arguments);
        this.render = () => {
            const { classes, size } = this.props;
            return (jsx_runtime_1.jsx("svg", Object.assign({ xmlns: "http://www.w3.org/2000/svg", fillRule: "evenodd", viewBox: "0 0 32 32", "aria-hidden": "true", className: classes.root, style: { width: size, height: size } }, { children: jsx_runtime_1.jsx("path", { d: "M32 32v-9.407h-1.475v-5.799h-2.553c0 .749.068 2.134.068 3.405h-1.475c-.069-1.702-.069-2.78-.069-3.473H24v5.402h-1.487v-5.436h-4.539l-4.187 7.251h-9.18L0 16l4.607-7.943h9.18l4.199 7.194H32V0v32zM12.959 9.532l-7.501-.034L1.702 16l3.756 6.502h7.501L16.715 16l-3.756-6.468zM9.248 19.96c-1.056.009-2.072-.404-2.822-1.148-.75-.743-1.172-1.756-1.172-2.812 0-2.183 1.766-3.954 3.949-3.96 2.183-.006 3.959 1.755 3.971 3.938.013 2.182-1.743 3.964-3.926 3.982zm0-6.434c-.664-.012-1.305.243-1.778.709-.474.465-.741 1.101-.741 1.765 0 1.36 1.099 2.465 2.459 2.473 1.36.008 2.472-1.083 2.488-2.443.017-1.36-1.068-2.479-2.428-2.504z" }, void 0) }), void 0));
        };
    }
}
UiconKeyHorizontal.propTypes = {
    classes: prop_types_1.default.object.isRequired,
    size: prop_types_1.default.number
};
UiconKeyHorizontal.defaultProps = {
    size: null
};
exports.default = react_jss_1.default(uicon_key_horizontal_style_1.default)(UiconKeyHorizontal);
//# sourceMappingURL=uicon.key.horizontal.js.map